import { render } from "./Wiki.vue?vue&type=template&id=0effe05b"
import script from "./Wiki.vue?vue&type=script&lang=js"
export * from "./Wiki.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__